<template>
  <DragDialog
    :title="getTitle()"
    :width="600"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel"
    class="editDialog"
  >
    <div class="common-form-box">
      <el-form class="public-form-primary" :model="form" :rules="rules" label-width="100px" ref="form">
        <el-form-item
          v-if="status !== 'resetPassword'"
          label="姓名:"
          prop="name"
        >
          <div class="common-input-box">
            <el-input
            class="input-primary"
              size="small"
              v-model="form.name"
              placeholder="请输入姓名"
              :maxlength="20"
              show-word-limit
            />
          </div>
        </el-form-item>
        <el-form-item
          v-if="status !== 'resetPassword'"
          label="用户名:"
          prop="userName"
        >
          <div class="common-input-box">
            <el-input
            class="input-primary"
              size="small"
              v-model="form.userName"
              placeholder="请输入用户名"
            />
          </div>
        </el-form-item>
        <el-form-item
          v-if="!(status === 'edit')"
          :label="`${status === 'resetPassword' ? '新' : ''}密码:`"
          prop="password"
        >
          <div class="common-input-box">
            <el-input
            class="input-primary"
              size="small"
              show-password
              v-model="form.password"
              placeholder="请输入密码"
              autocomplete="new-password"
            />
          </div>
        </el-form-item>
        <el-form-item
          v-if="!(status === 'edit')"
          label="确认密码:"
          prop="confirmPassword"
        >
          <div class="common-input-box">
            <el-input
            class="input-primary"
              size="small"
              show-password
              v-model="form.confirmPassword"
              placeholder="请确认密码"
              autocomplete="new-password"
            />
          </div>
        </el-form-item>
        <el-form-item
          v-if="status !== 'resetPassword'"
          label="手机号:"
          prop="phone"
        >
          <div class="common-input-box">
            <el-input
            class="input-primary"
              size="small"
              v-model="form.phone"
              placeholder="请输入手机号"
            />
          </div>
        </el-form-item>
        <el-form-item
          v-if="status !== 'resetPassword'"
          label="邮箱:"
          prop="email"
        >
          <div class="common-input-box">
            <el-input
            class="input-primary"
              size="small"
              v-model="form.email"
              placeholder="请输入邮箱"
            />
          </div>
        </el-form-item>
        <el-form-item
          v-if="status !== 'resetPassword'"
          label="公司:"
          prop="company"
        >
          <div class="common-input-box">
            <el-input
            class="input-primary"
              size="small"
              v-model="form.company"
              placeholder="请输入公司名称"
            />
          </div>
        </el-form-item>
        <el-form-item
          prop="enterpriseType"
          label="企业类型:"
          v-if="status !== 'resetPassword'"
        >
          <div class="item-box">
            <div class="common-select-box">
              <el-select
              class="primary-select"
                size="small"
                v-model="form.enterpriseType"
                placeholder="请选择您的企业类型"
                :popper-append-to-body="false"
              >
                <el-option value="施工单位">施工单位</el-option>
                <el-option value="设计单位">设计单位</el-option>
                <el-option value="建设方">建设方</el-option>
                <el-option value="科技公司">科技公司</el-option>
                <el-option value="高校">高校</el-option>
                <el-option value="其他">其他</el-option>
              </el-select>
            </div>
            <div class="common-input-box gl8" v-if="form.enterpriseType === '其他'">
              <el-input
              class="input-primary"
                size="small"
                placeholder="请输入您的企业类型"
                v-model="form.enterpriseTypeInput"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item
          prop="province"
          label="所在省份:"
          v-if="status !== 'resetPassword'"
        >
          <div class="common-select-box">
            <el-select
            class="primary-select"
            popper-class="primary-select-outer"
              size="small"
              v-model="form.province"
              filterable
              placeholder="请选择您的所在省份"
              :popper-append-to-body="true"
            >
              <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item
          prop="position"
          label="岗位:"
          v-if="status !== 'resetPassword'"
        >
          <div class="item-box">
            <div class="common-select-box">
              <el-select
              class="primary-select"
                size="small"
                v-model="form.position"
                :popper-append-to-body="false"
                placeholder="请选择您的岗位"
              >
                <el-option value="软件开发">软件开发</el-option>
                <el-option value="建模设计">建模设计</el-option>
                <el-option value="工程管理">工程管理</el-option>
                <el-option value="其他">其他</el-option>
              </el-select>
            </div>
            <div class="common-input-box gl8" v-if="form.position === '其他'">
              <el-input
              class="input-primary"
                size="small"
                placeholder="请输入您的岗位"
                v-model="form.positionInput"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item
        class="role"
          label="角色:"
          v-if="isChecked('User.UpdateRole') && status !== 'resetPassword'"
        >
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              v-model="form.roleId"
              filterable
              popper-class="primary-select-outer"
              placeholder="请选择角色"
            >
              <el-option
                v-for="(item, index) in roleList"
                :key="index"
                :label="item.roleName"
                :value="item.roleId"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item v-if="status !== 'resetPassword'" label="状态:">
          <div class="common-switch-box">
            <el-switch class="switch-primary" v-model="form.isActive" />
            <div :class="`switch-name ${form.isActive ? '' : 'disabled'}`">
              {{ form.isActive ? "启用" : "禁用" }}
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";

import { Store } from "@/utils/store";

import {
  userNameRules,
  nameRules,
  passwordRules,
  phoneRules,
  emailRules,
  companyRules,
  enterpriseTypeRules,
  positionRules,
} from "@/utils/formValidateRules";

import { encryptPassword } from "@/utils/generalMethods";
import {
  getUserRoleList,
  addUser,
  modifyUser,
  modifyUserPassword,
} from "@/service/interface";

const provinceList = [
  "北京市",
  "上海市",
  "天津市",
  "重庆市",
  "湖北省",
  "湖南省",
  "广东省",
  "河南省",
  "河北省",
  "山东省",
  "山西省",
  "江苏省",
  "江西省",
  "浙江省",
  "黑龙江省",
  "辽宁省",
  "吉林省",
  "甘肃省",
  "青海省",
  "陕西省",
  "海南省",
  "福建省",
  "安徽省",
  "云南省",
  "贵州省",
  "四川省",
  "广西壮族自治区",
  "宁夏回族自治区",
  "内蒙古自治区",
  "西藏自治区",
  "新疆维吾尔自治区",
  "台湾省",
  "香港特别行政区",
  "澳门特别行政区",
];
const enterpriseTypeList = [
  "施工单位",
  "设计单位",
  "建设方",
  "科技公司",
  "高校",
];
const positionList = ["软件开发", "建模设计", "工程管理"];
export default {
  data() {
    const validConfirmPassword = (rule, value, callback) => {
      if (value === this.form.password) {
        callback();
      } else {
        return callback(new Error("两次输入密码不一致"));
      }
    };
    const validEnterpriseTypeInput = (rule, value, callback) => {
      if (value === "其他") {
        if (this.form.enterpriseTypeInput) {
          if (enterpriseTypeRules.pattern.test(this.form.enterpriseTypeInput)) {
            callback();
          } else {
            return callback(new Error(enterpriseTypeRules.message));
          }
        } else {
          return callback(new Error("请输入企业类型"));
        }
      } else {
        callback();
      }
    };
    const validPositionInput = (rule, value, callback) => {
      if (value === "其他") {
        if (this.form.positionInput) {
          if (positionRules.pattern.test(this.form.positionInput)) {
            callback();
          } else {
            return callback(new Error(positionRules.message));
          }
        } else {
          return callback(new Error("请输入岗位"));
        }
      } else {
        callback();
      }
    };
    return {
      form: {
        userName: "",
        name: "",
        phone: "",
        email: "",
        company: "",
        enterpriseType: "",
        enterpriseTypeInput: "",
        province: "",
        position: "",
        roleId: undefined,
        positionInput: "",
        isActive: true,
        password: "",
        confirmPassword: "",
      },
      provinceList: provinceList,
      roleList: [],
      rules: {
        userName: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
          {
            pattern: userNameRules.pattern,
            message: userNameRules.message,
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
          {
            pattern: nameRules.pattern,
            message: nameRules.message,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            pattern: passwordRules.pattern,
            message: passwordRules.message,
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: "请确认密码",
            trigger: "blur",
          },
          {
            pattern: passwordRules.pattern,
            message: passwordRules.message,
            trigger: "blur",
          },
          { validator: validConfirmPassword, trigger: "blur" },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: phoneRules.pattern,
            message: phoneRules.message,
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
          {
            pattern: emailRules.pattern,
            message: emailRules.message,
            trigger: "blur",
          },
        ],
        company: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          },
          {
            pattern: companyRules.pattern,
            message: companyRules.message,
            trigger: "blur",
          },
        ],
        enterpriseType: [
          {
            required: true,
            message: "请输入企业类型",
            trigger: "change",
          },
          {
            pattern: enterpriseTypeRules.enterpriseType,
            message: enterpriseTypeRules.enterpriseType,
            trigger: "change",
          },
          { validator: validEnterpriseTypeInput, trigger: "blur" },
        ],
        position: [
          {
            required: true,
            message: "请输入职位",
            trigger: "change",
          },
          {
            pattern: positionRules.pattern,
            message: positionRules.message,
            trigger: "change",
          },
          { validator: validPositionInput, trigger: "blur" },
        ],
        province: [
          {
            required: true,
            message: "请选择省份",
            trigger: "change",
          },
        ],
      },
    };
  },
  props: {
    visible: Boolean,
    status: String,
    userInfo: Object,
    closeDialog: Function,
    queryUserList: Function,
  },
  components: {
    DragDialog,
  },
  mounted() {},
  watch: {
    visible: function (newValue) {
      if (newValue) {
        if (this.userInfo) {
          this.form = {
            userName: this.userInfo.surname,
            name: this.userInfo.name,
            phone: this.userInfo.phoneNumber,
            email: this.userInfo.email,
            company: this.userInfo.company,
            enterpriseType: this.userInfo.enterpriseType,
            province: this.userInfo.province,
            position: this.userInfo.position,
            isActive: this.userInfo.isActive,
            password: this.userInfo.password,
            confirmPassword: this.userInfo.password,
            roleId: this.userInfo.roleId,
          };
          if (!enterpriseTypeList.includes(this.userInfo.enterpriseType)) {
            this.$set(
              this.form,
              "enterpriseTypeInput",
              this.userInfo.enterpriseType
            );
            this.form.enterpriseType = "其他";
          }
          if (!positionList.includes(this.userInfo.position)) {
            this.$set(this.form, "positionInput", this.userInfo.position);
            this.form.position = "其他";
          }
        }

        // prettier-ignore
        if (this.isChecked("User.UpdateRole") && this.status !== 'resetPassword') {
          this.queryRoleList();
        }
      }
    },
  },
  methods: {
    getTitle() {
      let title = "";
      switch (this.status) {
        case "create":
          title = "新增用户";
          break;
        case "edit":
          title = "编辑用户";
          break;
        case "resetPassword":
          title = "重置密码";
          break;
      }
      return title;
    },
    submit() {
      this.$refs.form.validate((bool, object) => {
        if (bool) {
          let status = this.status;
          if (status === "create") {
            let params = JSON.parse(JSON.stringify(this.form));
            params.password = encryptPassword(params.password);
            params.confirmPassword = encryptPassword(params.confirmPassword);
            addUser(params).then((response) => {
              if (response.status === 200) {
                let data = response.data;
                if (data.isSuccess) {
                  this.queryUserList().then(() => {
                    this.$message.success("新建用户成功！！！");

                    this.cancel();
                  });
                } else {
                  this.$message.error(data.errMsg);
                }
              }
            });
            return;
          }

          if (status === "edit") {
            let params = {
              userName: this.form.userName,
              name: this.form.name,
              phone: this.form.phone,
              email: this.form.email,
              company: this.form.company,
              enterpriseType: this.form.enterpriseType,
              province: this.form.province,
              position: this.form.position,
              isActive: this.form.isActive,
              roleId: this.form.roleId,
              userId: this.userInfo.userId,
            };
            if (params.enterpriseType === "其他") {
              params.enterpriseType = this.form.enterpriseTypeInput;
            }
            if (params.position === "其他") {
              params.position = this.form.positionInput;
            }
            modifyUser(params).then((result) => {
              if (result.status === 200) {
                let response = result.data;
                if (response.isSuccess) {
                  this.queryUserList().then(() => {
                    this.$message.success("修改成功！！！");

                    this.cancel();
                  });
                } else {
                  this.$message.error(response.errMsg);
                }
              }
            });
            return;
          }

          if (status === "resetPassword") {
            let params = {
              password: encryptPassword(this.form.password),
              confirmPassword: encryptPassword(this.form.confirmPassword),
              userId: this.userInfo.userId,
            };
            modifyUserPassword(params).then((response) => {
              if (response.status === 200) {
                this.$message.success("修改成功！！！");

                this.cancel();
              }
            });
          }
        } else {
          this.$message.error("表单验证失败，请正确填写相关内容后再重新提交");
        }
      });
    },
    queryRoleList() {
      let params = { roleName: "" };
      getUserRoleList(params).then((result) => {
        if (result.status === 200) {
          let response = result.data;
          if (response.isSuccess) {
            let roleList = response.data;
            this.roleList = roleList;
          } else {
            this.$message.error(response.errMsg);
          }
        }
      });
    },
    cancel() {
      this.form = {
        userName: "",
        name: "",
        phone: "",
        email: "",
        company: "",
        enterpriseType: "",
        enterpriseTypeInput: "",
        province: "",
        position: "",
        positionInput: "",
        roleId: undefined,
        isActive: true,
        password: "",
        confirmPassword: "",
      };
      this.closeDialog();
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData;
      let find = permissionData.find(
        (el) => el.permissionCode === permissionCode
      );
      return find.isCheck;
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.editDialog{
  :deep(.dialog-content){
  }
}
.common-form-box {
  .common-input-box {
    // margin-left: 10px;
  }

  :deep(.el-form-item){
    &.is-required{
      margin-bottom: 22px;
    }

    .el-form-item__error{
      padding-top: 0 !important;
    }

    &.role{
      margin-bottom: 10px;
    }
  }

  .common-select-box {
    flex-grow: 1;
    // margin-left: 10px;

    .el-select {
      width: 100%;

      :deep(.el-input__inner){
        font-family: '';
      }
    }
  }

  .common-switch-box {
    display: flex;
    // margin-left: 10px;

    .switch-name {
      color: var(--default-color);
      margin-left: 4px;
    }

    .disabled {
      opacity: 0.6;
    }
  }

  .item-box {
    display: flex;
  }
}
</style>